import React, { ReactElement } from 'react';
import styles from './Banner.module.scss';
import { Button } from "@kursk/components/ui/Button/Button";
import { ArrowDownIcon } from "@kursk/components/ui/icons";

export function Banner(): ReactElement {

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <img className={styles.image} srcSet='/images/pushkin-banner.svg'/>
        <div className={styles.category}>Программа популяризации культурных мероприятий среди молодежи</div>
        <div className={styles.bannerButton}>
          <Button
            className={styles.buttonPink}
            href={'/events/tag-pushkinskaya-karta'}
          >
            <div className={styles.buttonTextWrapper}>
              <div className={styles.buttonPrimaryText}>Смотреть Афишу</div>
              <ArrowDownIcon width={12} height={5} />
            </div>
          </Button>
        </div>
        <img className={styles.pushkin} srcSet='/images/pushkin.svg'/>
        <div className={styles.imageSection}>
          <a href='https://digital.gov.ru/ru' target="_blank" rel="noreferrer">
            <img className={styles.mincifry} srcSet='/images/mincifry.svg'/>
          </a>
          <a href='https://culture.gov.ru/' target="_blank" rel="noreferrer">
            <img className={styles.minkult} srcSet='/images/minkult.svg'/>
          </a>
        </div>
      </div>
    </div>
  );
}
